import React, { useEffect } from 'react';
import Instructions from '../instructions';
import * as S from './styles.js';

const SimulateStart = ({
  loading,
  startDate,
  currentDate,
  history,
  doStartSimulation,
  setShowInstructions,
}) => {
  useEffect(() => {
    if(!startDate) return;
    if(currentDate === -999) return;
  }, [startDate, currentDate]);

  const handleOpenInstructions = () => {
    setShowInstructions(true);
  };
  return (
    <S.Container>
      <Instructions
        loading={loading}
        history={history}
        startDate={startDate}
        doStartSimulation={doStartSimulation}
        isInstructionStarted={handleOpenInstructions}
      />
    </S.Container>
  );
};

export default SimulateStart;
